module.exports = __webpack_public_path__ + "html/custom-template-table.component.html";